"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Label = _interopRequireDefault(require("../../structure/Label"));
var _FormRow = _interopRequireDefault(require("../../structure/FormRow"));
var _FormHint = _interopRequireDefault(require("../../structure/FormHint"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function DropdownComponent(props) {
  var id = props.id,
    name = props.name,
    inputRef = props.inputRef,
    value = props.value,
    choices = props.choices,
    _onChange = props.onChange,
    children = props.children,
    rowClass = props.rowClass,
    disabled = props.disabled,
    required = props.required,
    errors = props.errors,
    warning = props.warning,
    info = props.info,
    labelClass = props.labelClass,
    _props$inputClass = props.inputClass,
    inputClass = _props$inputClass === void 0 ? 'form-element form-element--dropdown' : _props$inputClass,
    _props$errorClass = props.errorClass,
    errorClass = _props$errorClass === void 0 ? 'form-element--has-error' : _props$errorClass;
  var selected = value === null && choices.default ? 'default' : value !== null && value !== void 0 ? value : '';
  var optionElements = (0, _react.useMemo)(function () {
    var options = Object.keys(choices).filter(function (key) {
      return key !== 'default';
    }).map(function (key) {
      return /*#__PURE__*/React.createElement("option", {
        value: key,
        key: key
      }, choices[key]);
    });
    if (choices.default) {
      return [/*#__PURE__*/React.createElement("option", {
        value: "",
        key: "default"
      }, choices.default)].concat(_toConsumableArray(options));
    }
    return options;
  }, [choices]);
  var hasErrors = !!errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : '';
  var inputClassName = hasErrors ? "".concat(inputClass, " ").concat(errorClass) : inputClass;
  return /*#__PURE__*/React.createElement(_FormRow.default, {
    className: rowClass,
    hasErrors: hasErrors
  }, /*#__PURE__*/React.createElement(_Label.default, {
    id: id,
    className: labelClass
  }, children), /*#__PURE__*/React.createElement("select", {
    ref: inputRef,
    id: id,
    name: name,
    value: selected,
    className: inputClassName,
    onChange: function onChange(event) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(event.target.value);
    },
    disabled: disabled,
    required: required
  }, optionElements), /*#__PURE__*/React.createElement(_FormHint.default, {
    error: errorMessage,
    warning: warning,
    info: info
  }));
}
function Dropdown(props, ref) {
  return /*#__PURE__*/React.createElement(_reactHookForm.Controller, _extends({}, props, {
    render: function render(_ref) {
      var _ref$field = _ref.field,
        _onChange2 = _ref$field.onChange,
        onBlur = _ref$field.onBlur,
        value = _ref$field.value;
      return /*#__PURE__*/React.createElement(DropdownComponent, _extends({
        inputRef: ref !== null && ref !== void 0 ? ref : null
      }, props, {
        onChange: function onChange(payload) {
          _onChange2(payload);
          if (typeof props.onChange === 'function' && payload) {
            props.onChange(payload);
          }
        },
        onBlur: onBlur,
        value: String(value !== null && value !== void 0 ? value : '')
      }));
    }
  }));
}
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(Dropdown);